import EventEmitter from 'events';
import camelcaseKeys from 'camelcase-keys';
let captions = [];
let webSocket;
export const emitter = new EventEmitter();
export const WS_PROTOCOL = window.location.protocol === 'https:' ? 'wss:' : 'ws:';
const handleSocketMessage = async (event) => {
    const apiMessage = camelcaseKeys(JSON.parse(event.data), { deep: true });
    if (apiMessage.subsystem === 'LiveSubtitlesStreaming' && apiMessage.data !== undefined) {
        captions.push(apiMessage.data);
        emitter.emit('newCaption');
    }
};
export const connectLiveCaptions = async (projectId, host, connection) => {
    webSocket = new WebSocket(`${WS_PROTOCOL}//${host}/ws/LiveUpdate?Authorization=${await connection.retrieveAuthString()}&projectId=${projectId}&usermessages=false`);
    webSocket.onopen = () => emitter.emit('connected');
    webSocket.onmessage = handleSocketMessage;
    captions = [];
};
export const getCaptionsBegin = () => { var _a, _b; return (_b = (_a = captions[0]) === null || _a === void 0 ? void 0 : _a.begin) !== null && _b !== void 0 ? _b : 0; };
export const getCaptionsEnd = () => { var _a, _b; return (_b = (_a = captions[captions.length - 1]) === null || _a === void 0 ? void 0 : _a.end) !== null && _b !== void 0 ? _b : 0; };
export const getCurrentCaptions = (currentTime) => captions.filter((caption) => caption.begin <= currentTime && caption.end > currentTime);
export const closeLiveCaptions = () => {
    webSocket === null || webSocket === void 0 ? void 0 : webSocket.close();
    webSocket = null;
    emitter.removeAllListeners();
};
